module.exports = __webpack_public_path__ + "be.no2.622556d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/be.no2.jpg
// module id = OThk
// module chunks = 0